import { Init } from "@pdfking/reactivity/preact"
import { scan } from "@pdfking/rfunc"
import { CreateSingleton } from "@pdfking/tfunc"
import { settings_get } from "@pdfking/workflow/state/settings"
import serialize_error from "../utils/serialize_error"
import user from "./user"

export default CreateSingleton(() =>
  Init({
    computed: {
      user() {
        return user
      },
    },
    data: {
      AJAX_COUNTER: 0,
      AJAX_REQUEST_CACHE: {},
      IS_SUBMITTED: false,
      LAST_FOCUS: null,
      request_id: null,
    },
    methods: {
      track_error(error, error_type) {
        this.track_event(`${error}`, error_type)
        serialize_error(error)
      },
      track_event(...args) {
        // @ts-expect-error TS2349
        scan(func => func(...args), settings_get("event_handlers"))
      },
    },
  })
)
